
const state = {
    sickLeaves: []
}

export default state
